const load = component => () => import(`@/views/${component}.vue`)

export default [
  {
    path: '/',
    name: 'home',
    component: load('Home')
  },
  {
    path: '/login',
    name: 'login',
    component: load('Login'),
    meta: {
      auth: false,
      layout: 'login'
    }
  },
  {
    path: '/templates',
    name: 'templates',
    component: load('Templates')
  },
  {
    path: '/sending',
    name: 'sending',
    component: load('Sending')
  },
  {
    path: '/sending/:id',
    component: load('SendingDetails')
  },
  {
    path: '/sms-list',
    name: 'sms-list',
    component: load('SmsList')
  },
  {
    path: '/404',
    alias: '*',
    name: 'error',
    component: load('Error')
  }
]
